import { render, staticRenderFns } from "./DocTemplateList.vue?vue&type=template&id=a57ddc2e&scoped=true"
import script from "./DocTemplateList.vue?vue&type=script&lang=js"
export * from "./DocTemplateList.vue?vue&type=script&lang=js"
import style0 from "./DocTemplateList.vue?vue&type=style&index=0&id=a57ddc2e&lang=scss"
import style1 from "./DocTemplateList.vue?vue&type=style&index=1&id=a57ddc2e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57ddc2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a57ddc2e')) {
      api.createRecord('a57ddc2e', component.options)
    } else {
      api.reload('a57ddc2e', component.options)
    }
    module.hot.accept("./DocTemplateList.vue?vue&type=template&id=a57ddc2e&scoped=true", function () {
      api.rerender('a57ddc2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/wps/DocTemplateList.vue"
export default component.exports